import { useEffect, useState } from 'react';
import api from '@/lib/api';
import { applyPlatformBranding } from '@/lib/platformBranding';

export default function usePlatformBranding({ enabled = true } = {}) {
  const [branding, setBranding] = useState(null);

  useEffect(() => {
    if (!enabled) return;

    let cancelled = false;
    api.get('/public/platform-branding')
      .then((res) => {
        if (cancelled) return;
        const data = {
          name: res.data.platform_name || 'Tokomoe',
          faviconUrl: res.data.platform_favicon_url || '',
          logoUrl: res.data.platform_logo_url || '',
          primaryColor: res.data.primary_color || '#2D6CDF',
        };
        setBranding(data);
        applyPlatformBranding(data);
      })
      .catch(() => {});

    return () => { cancelled = true; };
  }, [enabled]);

  return branding;
}
